import { useState, useEffect, useMemo } from "react";

import Button from "components/Button/Button";
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import {
  List,
  ListItem,
  Stack,
  Text /*HStack, Badge*/,
} from "@chakra-ui/layout";
import { useDisclosure } from "@chakra-ui/hooks";
// import { Image } from "@chakra-ui/image";

import SubmitPin from "../SubmitPin";

// import capitalize from "lodash/capitalize";
// import toUpper from "lodash/toUpper";

import toPrecision from "util/toPrecision";
// import currencyFormatter from "util/formatter";
import toCoinLocale from "util/toCoinLocale";

const Item = ({ name, value }) => {
  return (
    <ListItem py="10px" borderBottom="1px solid #EAEAEA">
      <Stack>
        <Text fontSize="xs">{name}</Text>
        <Text mt="0px !important">{value}</Text>
      </Stack>
    </ListItem>
  );
};

const ForStep1 = ({ state, setState, isOpen, onClose, onConfirm }) => {
  const network = useMemo(() => {
    const map = {
      tron: "Tron (TRC20)",
      ethereum: "Ethereum (ERC20)",
    };

    return map[state?.network];
  }, [state?.network]);

  const items = [
    {
      name: "Address",
      value: state?.username ? `@${state?.username}` : state?.address,
    },
    { name: "Coin Type", value: toCoinLocale(state?.coin) },
    { name: "Amount", value: toPrecision(state?.amount, state?.coin) },
    !state?.isInternalWallet && {
      name: "Fees Charged",
      value: toPrecision(state?.fees, state?.coin),
    },
    { name: "Status", value: state?.status },
    { name: "Destination", value: state?.destination },
    {
      name: "Fees Charged",
      value: state?.isInternalWallet
        ? toPrecision(0, state?.coin)
        : state?.otherFees,
    },
    { name: "Network", value: network },
  ];

  const handleSubmit = (pin) => {
    // setState(() => ({ pin }));
    onClose();

    onConfirm && onConfirm();
  };

  return (
    <>
      <Stack>
        <List>
          {items.map((item, i) => item?.value && <Item key={i} {...item} />)}
        </List>
      </Stack>

      <SubmitPin
        isOpen={isOpen}
        onClose={onClose}
        onSubmit={handleSubmit}
        onPin={(pin) => setState({ pin })}
      />
    </>
  );
};

const WithdrawPreview = ({
  isOpen,
  onClose,
  state,
  setState,
  onConfirm,
  isLoading,
  title,
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  // const maxStep = 1;

  const {
    isOpen: isSubmitPinOpen,
    onClose: onSubmitPinClose,
    onOpen,
  } = useDisclosure();

  const previewMap = (step) => {
    const map = {
      0: (
        <ForStep1
          state={state}
          setState={setState}
          isOpen={isSubmitPinOpen}
          onClose={onSubmitPinClose}
          onConfirm={onConfirm}
        />
      ),
    };

    return map[step];
  };

  // const handlePrev = () => {
  //   if (currentStep > 0) {
  //     setCurrentStep(currentStep - 1);
  //   } else {
  //     onClose();
  //   }
  // };

  const handleNext = () => {
    // if (currentStep < maxStep - 1) {
    //   setCurrentStep(currentStep + 1);
    // } else {
    //   onConfirm && onConfirm();
    // }
    onOpen();
  };

  useEffect(() => setCurrentStep(0), [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent bg="#F8F9FD" overflow="hidden" borderRadius="16px">
        <ModalHeader p="26px 0" textAlign="center" bg="white" fontSize="md">
          {title}
        </ModalHeader>
        <ModalCloseButton
          top="23px"
          right="20px"
          _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
        />
        <ModalBody p="24px 48px">{previewMap(currentStep)}</ModalBody>

        <ModalFooter justifyContent="center" pb="30px" gridGap="14px">
          <Button
            minW="120px"
            w="100%"
            minH="50px"
            disabled={isLoading}
            onClick={handleNext}
            // bg="transparent"
            // border="2px solid transparent"
            // color="#03A438"
          >
            Continue
          </Button>
          {/* <Button
            disabled={isLoading}
            isLoading={isLoading}
            minW="120px"
            onClick={handleNext}
          >
            {currentStep === maxStep - 1
              ? forUpdate
                ? "Update"
                : buttonText && buttonText[1]
                ? buttonText[1]
                : "Buy"
              : "Next"}
          </Button> */}
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WithdrawPreview;
